import { d as n } from "./document-all.js";
var t = n.all,
  o = n.IS_HTMLDDA ? function (n) {
    return "function" == typeof n || n === t;
  } : function (n) {
    return "function" == typeof n;
  };
export { o as i };